<template>
    <div class="loading-spinner-overlay">
        <div class="spinner-overlay"></div>
    </div>
</template>

<script>
// NOTE: PARENT ELEMENT MUST BE SET TO position: relative

export default {
name: "LoadingSpinnerOverlay"
}
</script>

<!--  lang="scss" -->
<style>
.loading-spinner-overlay {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 200;
    background: rgba(0,0,0,0.1);

    font-weight: bold;
    text-align: center;
}

/* https://codeburst.io/how-to-create-a-simple-css-loading-spinner-make-it-accessible-e5c83c2e464c */
@keyframes spinner-overlay {
    0% {
        transform: translate3d(-50%, -50%, 0) rotate(0deg);
    }
    100% {
         transform: translate3d(-50%, -50%, 0) rotate(360deg);
    }
}
.spinner-overlay {
    /* The height here is just for demo purposes */
    height: 100%;
    opacity: 1;
    position: relative;
    transition: opacity linear 0.1s;
}
.spinner-overlay::before {
    animation: 1s linear infinite spinner-overlay;
    border: solid 15px #eee;
    border-bottom-color: #EF6565;
    border-radius: 50%;
    content: "";
    height: 100px;
    left: 50%;
    opacity: inherit;
    position: absolute;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
    transform-origin: center;
    width: 100px;
    will-change: transform;
}

</style>